<!--primary, accent, or warn  -->
<mat-toolbar class="flex justify-between">
  <!-- justify-between justify-center -->
  <div class="flex gap-1">
    @if (homeVisible) {
      <button (click)="setRoot('/')" class="btn-primary">
        <mat-icon>home</mat-icon>
      </button>
    }
    @if (backVisible) {
      <button (click)="doBack()" class="btn-primary">
        回上頁
        <!-- <mat-icon>arrow_back</mat-icon> -->
      </button>
    }
  </div>
  <div>
    <span class="jk-title">{{ label() }}</span>
  </div>
  <div>
    @if (user1Visible) {
      <button (click)="user1Click()" class="btn-neutral">
        {{ user1Text }}
      </button>
    }
    @if (user2Visible) {
      <button (click)="user2Click()" class="btn-neutral">
        {{ user2Text }}
      </button>
    }
    @if (user3Visible) {
      <button (click)="user3Click()" class="btn-neutral">
        {{ user3Text }}
      </button>
    }
    @if (user4Visible) {
      <button (click)="user4Click()" class="btn-neutral">
        {{ user4Text }}
      </button>
    }
    @if (user5Visible) {
      <button (click)="user5Click()" class="btn-neutral">
        {{ user5Text }}
      </button>
    }
    <button
      [matMenuTriggerFor]="menu"
      aria-label="Example icon-button with a menu"
      class="btn-primary"
    >
      <mat-icon>more_vert</mat-icon>
    </button>
  </div>
</mat-toolbar>

<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="menuClick('add')">
    <mat-icon>add</mat-icon>
    <span>新增</span>
  </button>
  <button mat-menu-item (click)="menuClick('search')">
    <mat-icon>search</mat-icon>
    <span>查詢</span>
  </button>
  <button mat-menu-item (click)="menuClick('refresh')">
    <mat-icon>refresh</mat-icon>
    <span>重新整理</span>
  </button>
  <button mat-menu-item (click)="menuClick('arrow_upward')">
    <mat-icon>arrow_upward</mat-icon>
    <span>至頂端</span>
  </button>
</mat-menu>
